import gql from "graphql-tag";

export const stopModel = gql`
  mutation StopModel(
    $input: StopModelInput!) {
    stopModel(input: $input) {
      project {
        id
        models {
            id
            status
            trialEnds
        }
      }
    }
  }
`;

export const stopModelOptions = {
  name: "stopModel",
};
